export default __webpack_public_path__ + "static/media/class-passes.9d00f45f.svg";